export const priceOverridesSection = "/price-overrides/";

export const priceOverridesPath = priceOverridesSection;

export const priceOverridesChannelsPath = `${priceOverridesSection}channels/`;
export const priceOverridesCategoriesPath = `${priceOverridesSection}categories/`;
export const priceOverridesProductsPath = `${priceOverridesSection}products/`;
export const priceOverridesPriceCheckPath = `${priceOverridesSection}price-check/`;

export const priceOverridesUrl = () => priceOverridesPath;
export const priceOverridesChannelsUrl = () => priceOverridesChannelsPath;
export const priceOverridesCategoriesUrl = () => priceOverridesCategoriesPath;
export const priceOverridesProductsUrl = () => priceOverridesProductsPath;
export const priceOverridesPriceCheckUrl = () => priceOverridesPriceCheckPath;
